import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminTiposSolicitudCatalogoPage } from "@/features/admin-tipos-solicitud-catalogo/components/AdminTiposSolicitudCatalogoPage";
import { tiposSolicitudCatalogoAdminQueryOptions } from "@/features/admin-tipos-solicitud-catalogo/hooks/use-tipos-solicitud-catalogo-admin";

/** Ruta `/admin/tipos-solicitud-catalogo` · configuración de los tipos de solicitud de catálogo. */
export const Route = createFileRoute("/_authed-tw/admin/tipos-solicitud-catalogo")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminTiposSolicitudCatalogo])
      ? queryClient.ensureQueryData(tiposSolicitudCatalogoAdminQueryOptions)
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminTiposSolicitudCatalogo]}>
      <AdminTiposSolicitudCatalogoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
